import React, {Component} from 'react';
import './VideoSlider.css';
import '../../../Common/Common.css';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import PCBImage1 from '../../../../assets/img/pcb_image_slider.jpg';
import PCBImage2 from '../../../../assets/img/pcb_image_slider.jpg';
import Slider from './Slider/Slider'
import {FormattedMessage} from "react-intl";

class VideoSlider extends Component {
    handleOnDragStart = e => e.preventDefault();
    render() {
        return (
            <div className="row">
            <div className="video-slider" id="video-slider-div1">
                {/*<div className="homepage-heading">
                    <FormattedMessage id="app.home-content.video-slider.heading"
                                      defaultMessage="Substrate Manufacturing Process"
                                      description=""/>
                </div>*/}
                <div className="video-slider-caption">
                    <FormattedMessage id="app.home-content.video-slider.caption1"
                                      defaultMessage="One of the world's largest prototype board manufacturing processes used by more than 600,000 people worldwide."
                                      description=""/>
                    <br/>
                    <FormattedMessage id="app.home-content.video-slider.caption2"
                                      defaultMessage=" We manufacture over 10,000 printed circuit boards per day."
                                      description=""/>
                </div>
                <div className="video-carousel">
                    <Slider/>
                </div>


                {/*<AliceCarousel mouseDragEnabled >*/}
                    {/*<img src={PCBImage1} onDragStart={this.handleOnDragStart.bind(this)} className="pcb-video-slider" />*/}
                    {/*<img src={PCBImage2} onDragStart={this.handleOnDragStart.bind(this)} className="pcb-video-slider" />*/}


                {/*</AliceCarousel>*/}





            </div>
            </div>
        );
    }
}

export default VideoSlider;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/VideoSlider/VideoSlider.js